import { VIEW_REQUEST_IS_DISCLOSE } from '@/utils/constants/viewRequest/isDisclose';
import { VIEW_REQUEST_IS_DISCLOSE_APPROVED } from '@/utils/constants/viewRequest/isDiscloseApproved';
// 案件：開示状態 「開示」か
export const getIsDisclose = (isDisclose) => isDisclose === VIEW_REQUEST_IS_DISCLOSE;
// 案件: 開示済か
export const getIsDiscloseApproved = (isDiscloseApproved) => isDiscloseApproved === VIEW_REQUEST_IS_DISCLOSE_APPROVED.value;
